import React from "react";
import { Alert, Col, Row, Select } from "antd";

import { getSitesRequest } from "../../api/requests";
import isAuthenticated from "../../utils/isAuthenticated";

import classes from "./RandomizePage.css";
import { Helmet } from "react-helmet";

import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import find from "lodash/find";
import { logout } from "../../reducers/user/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withParams } from "../../utils/url";
import {
  getRandomizationStatusMessage,
  getRandomizationStopped,
} from "../../reducers/user/selectors";

const routes = require("../../routes.json");

const { Option } = Select;

class RandomizePreConsentStep1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      sites: [],
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getSitesRequest();

      const sites = data.filter((item) => item.site_type === "randomization");

      if (sites.length === 1) {
        const site = sites[0];

        if (get(site, "consent_active")) {
          this.props.history.push(
            withParams(routes.admin.consentRandomization, {
              site: get(site, "code"),
              workflow: get(site, "consent_workflow_type", ""),
            })
          );
        } else {
          window.location.href = withParams(routes.admin.randomize, {
            siteCode: get(site, "code"),
            workflow: get(site, "consent_workflow_type", ""),
          });
        }
      } else {
        this.setState({
          sites,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  //this.props.history.push(routes.admin.consentRandomization);

  render() {
    const { sites } = this.state;

    return (
      <div className={classes.wrapper}>
        <Helmet>
          <title>
            {this.props.i18n.t("Trial Management Portal")}:{" "}
            {this.props.i18n.t("Dashboard")}
          </title>
        </Helmet>
        <div className={classes.parentContainer}>
          <div className={classes.content}>
            {this.props.randomizationNotPossibleMessage ? (
              <Row>
                <Col md={24}>
                  <Alert
                    message={
                      <b>{this.props.randomizationNotPossibleMessage}</b>
                    }
                    type="error"
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}

            <h3>{this.props.i18n.t("Select randomization site")}</h3>

            <Select
              size="large"
              placeholder={this.props.i18n.t("Select Site ID")}
              style={{ width: "360px" }}
              showSearch
              disabled={get(this.props, "randomizationStopped", false)}
              optionFilterProp="children"
              filterOption
              onChange={(val) => {
                const site = sites.find(({ code }) => val === code);
                if (
                  get(
                    find(sites, ({ code }) => code === val),
                    "consent_active"
                  )
                ) {
                  this.props.history.push(
                    withParams(routes.admin.consentRandomization, {
                      site: val,
                      workflow: get(site, "consent_workflow_type", ""),
                    })
                  );
                } else {
                  window.location.href = withParams(routes.admin.randomize, {
                    siteCode: val,
                    workflow: get(site, "consent_workflow_type", ""),
                  });
                }
              }}
            >
              {sites
                .filter((site) => site.site_type === "randomization")
                .sort(
                  (a, b) =>
                    +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                )
                .map((site) => (
                  <Option key={site.code} value={site.code}>
                    {site.code} - {site.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  randomizationStopped: getRandomizationStopped(state),
  randomizationNotPossibleMessage: getRandomizationStatusMessage(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(RandomizePreConsentStep1)))
);



// WEBPACK FOOTER //
// ./src/containers/RandomizePage/RandomizePreConsentStep1.js